import { render } from "./EmoticonOutline.vue.js?vue&type=template&id=112f047a!=!../vue-loader/dist/index.js??ruleSet[0]!./EmoticonOutline.vue?vue&type=template&id=112f047a"
import script from "./EmoticonOutline.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./EmoticonOutline.vue?vue&type=script&lang=js"
export * from "./EmoticonOutline.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./EmoticonOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__